<template>

    <section class="w-100 d-flex flex-column">

        <!-- Breadcrumb -->
        <div class="d-flex flex-column order-1">

            <h1 class="order-1">Blog Category Form</h1>
            <!-- Back To -->
            <back-to 
                :urlreference="moduledefaultindex"
            />

        </div>

        <!-- Content -->
        <div v-if="showformcreate || showformupdate" class="d-flex order-2">

            <!-- Module Form -->
            <module-form 
                :csrftolken="csrftolken"
                :routine="moduleroutine"
                :moduleindex="moduleindex"
                :routineurl="routineurl"
                :moduledata="moduleData"
                :mediainsert="mediainsert"
                :imagestoragepath="imagestoragepath"
            />

        </div>
        
        <div v-else class="d-flex order-2 mt-5">
            <span>Não existem dados para esta solicitação</span>
        </div>

    </section>

</template>
<script>
import BackTo from './../elements/BackToElement.vue';
import ModuleForm from './BlogCategoryForm.vue';

//Set Use Strict
"use strict";

export default{
    name: 'BlogCategoryRoutine',
    props:{

        csrftolken:{
            type: String,
            required: true
        },
        moduleindex:{
            type: String,
            required: true
        },
        moduleroutine:{
            type: String,
            required: true
        },
        routineurl:{
            type: String,
            required: true
        },
        moduledata:{
            type: String,
            required: true
        },
        moduledefaultindex:{
            type: String,
            required: false
        },
        customdata:{
            type: String,
            required: false
        },
        mediainsert:{
            type: String,
            required: true
        },
        imagestoragepath:{
            type: String,
            required: true
        },

    },
    data: () => {

        return {

            showformcreate: true,
            showformupdate: true,
            moduleData: [],
            urlback: '',
            ruleList: []

        }

    },
    created(){

        //Set Customer Card Plan
        this.moduleData = JSON.parse(this.moduledata);

        //Set Conditional
        this.showformcreate = this.moduleData.length === 0 && this.moduleroutine === 'POST' ? true : false;
        this.showformupdate = this.moduleData.length > 0 && this.moduleroutine === 'PUT' ? true : false;

        //Set Url Back
        //this.urlback = history.back();

    },
    methods:{

        

    },
    components:{

        backTo: BackTo,
        moduleForm: ModuleForm,

    }

}

</script>